module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAAXNSR0IArs4c6QAAAIRJREFUKBVjYIxl/g/CDEAAo0FsEMDFh+lhgihDJRnjmJ8ii6AbApMDa/6/+C8jTABEc7KwmyLz0eXhfFymImvGxgbpY4FJkGIIzGa4ZpgAzDBiaLhmYmxGtwCuGV2C6jaDDES2hL42I9tOO5uR/YctACmymZGY+MVmK0gMa67CpRhdHADaQTngjRO3fwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-analysis.png
// module id = eMnv
// module chunks = 1 10 15 16 17 18 19 20 21